// extracted by mini-css-extract-plugin
module.exports = {"module":"styles_module__2pni5","rounded":"styles_rounded__eIAMG"};